<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 class="title-bar" mat-dialog-title>
        <span class="dialog-title">{{title}}</span>
    </h1>
    <div class="centerwrap scroll content" fxFlex.gt-sm="auto">
        <div class="dialog-message" [innerHTML]="message | safeHTML"></div>
        <mat-progress-bar mode="determinate" [value]="time"></mat-progress-bar>
    </div>
    <div
        class="button-bar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center center"
        fxLayoutGap.lt-md="10px"
    >
        <button mat-raised-button color="warn" class="angular cancelbtn" (click)="CancelHandler()">
            <span>{{canceltext}}</span>
        </button>
        <button mat-raised-button color="primary" class="angular okbtn" (click)="OKHandler()">
            <span>{{oktext}}</span>
        </button>
    </div>
</div>
